import { FETCH_STATIC_PAGES } from "../actions/actionTypes";

const initialState = {
  pages: [],
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_STATIC_PAGES:
      return { ...initialState, pages: payload };
    default:
      return state;
  }
};
